/** @format */

import { defaultActions } from '../../core/actionsDefault';
import { actionDebug } from '../../core/debug';

export function platformUserReducers(state = {}, action) {
    actionDebug('platformUser reducer: ' + action.type);
    switch (action.type) {
        case platformUserConstants.ROLE_USER:
            return {
                type: action.type,
                roles: action.collections,
            };
        default:
            return { ...state };
    }
}

export const platformUserConstants = {
    ROLE_USER: 'role_user',
    LIST: 'platform_user_list',
    ITEM: 'platform_user_item',
    SAVE_ITEM: 'platform_user_item_save',
    DELETE: 'platform_user_item_delete',
};

export class platformUserActions extends defaultActions {}
